module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainApp"
  }, [_c('router-view', {
    staticClass: "router-view"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0ed54eea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 574
// module chunks = 2